import templateUrl from "emun.cart/guest-checkout/guest-checkout.htm";
import controller from "emun.cart/guest-checkout/guest-checkout.controller";
import "emun.cart/guest-checkout/guest-checkout.scss";

export default {
  templateUrl,
  controller,
  bindings: {
  }
};
